import React from 'react';
import { motion } from 'framer-motion';
import { Award, Users, Globe, Zap } from 'lucide-react';

const values = [
  {
    icon: Award,
    title: "Excellence",
    description: "We pursue excellence in every project, setting the highest standards for creative work."
  },
  {
    icon: Users,
    title: "Collaboration",
    description: "Working closely with our clients to understand and achieve their vision."
  },
  {
    icon: Globe,
    title: "Innovation",
    description: "Staying ahead of trends and technology to deliver cutting-edge solutions."
  },
  {
    icon: Zap,
    title: "Impact",
    description: "Creating meaningful content that drives real business results."
  }
];

export default function About() {
  return (
    <div className="page-container">
      <div className="content-container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h1 className="float-slow">
            About <span className="text-golden">Us</span>
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto float-medium">
            We're a team of creative professionals passionate about helping brands tell their stories and connect with their audience in meaningful ways.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-12 items-center mb-12">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            className="float-medium"
          >
            <h2 className="text-3xl font-bold mb-6">Our Story</h2>
            <p className="text-gray-300 mb-4">
              Founded in 2020, DS Marketing emerged from a vision to transform how brands connect with their audience. We saw a gap between traditional marketing approaches and the dynamic needs of modern businesses.
            </p>
            <p className="text-gray-300">
              Today, we're proud to be working with some of the most innovative brands across the globe, helping them create content that not only looks beautiful but drives real business results.
            </p>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            className="relative float-slow"
          >
            <img
              src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&q=80"
              alt="Our team at work"
              className="rounded-2xl"
            />
          </motion.div>
        </div>

        <div className="mb-12">
          <h2 className="text-3xl font-bold text-center mb-8 float-medium">Our Values</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {values.map((value, index) => (
              <motion.div
                key={value.title}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className={`bg-card-gradient p-6 rounded-2xl border border-gray-800 float-${index % 2 === 0 ? 'slow' : 'medium'}`}
              >
                <value.icon className={`w-12 h-12 text-golden mb-4 float-${index % 2 === 0 ? 'medium' : 'fast'}`} />
                <h3 className="text-xl font-bold mb-2">{value.title}</h3>
                <p className="text-gray-300">{value.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}